/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type ThisIsATreePage_viewer$ref = any;
export type ThisIsATreePage_QueryVariables = {};
export type ThisIsATreePage_QueryResponse = {
    readonly viewer: ({
        readonly id: string | null;
        readonly " $fragmentRefs": ThisIsATreePage_viewer$ref;
    }) | null;
};
export type ThisIsATreePage_Query = {
    readonly response: ThisIsATreePage_QueryResponse;
    readonly variables: ThisIsATreePage_QueryVariables;
};



/*
query ThisIsATreePage_Query {
  viewer {
    id
    ...ThisIsATreePage_viewer
  }
}

fragment ThisIsATreePage_viewer on Viewer {
  id
  isLoggedIn
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ThisIsATreePage_Query",
            "type": "Root",
            "metadata": null,
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "FragmentSpread",
                            "name": "ThisIsATreePage_viewer",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "ThisIsATreePage_Query",
            "argumentDefinitions": [],
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isLoggedIn",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "ThisIsATreePage_Query",
            "id": null,
            "text": "query ThisIsATreePage_Query {\n  viewer {\n    id\n    ...ThisIsATreePage_viewer\n  }\n}\n\nfragment ThisIsATreePage_viewer on Viewer {\n  id\n  isLoggedIn\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f6e5d78b814650c616d9f394527d3845';
export default node;
